// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";

function use(reducer, initialState) {
  let cleanupEffects = React.useRef([]);
  let match = React.useReducer((fullState, action) => {
    let state = reducer(fullState.state, action);
    if (typeof state !== "object") {
      return fullState;
    }
    switch (state.TAG) {
      case "Update" :
        return {
          state: state._0,
          sideEffects: fullState.sideEffects
        };
      case "UpdateWithSideEffects" :
        return {
          state: state._0,
          sideEffects: {
            contents: Belt_Array.concatMany([
              fullState.sideEffects.contents,
              [state._1]
            ])
          }
        };
      case "SideEffects" :
        return {
          state: fullState.state,
          sideEffects: {
            contents: Belt_Array.concatMany([
              fullState.sideEffects.contents,
              [state._0]
            ])
          }
        };
    }
  }, {
    state: initialState,
    sideEffects: {
      contents: []
    }
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let sideEffects = match$1.sideEffects;
  let state = match$1.state;
  React.useEffect(() => {
    if (sideEffects.contents.length !== 0) {
      let sideEffectsToRun = sideEffects.contents.slice();
      sideEffects.contents = [];
      let cancelFuncs = Stdlib_Array.filterMap(sideEffectsToRun, func => func({
        dispatch: dispatch,
        state: state
      }));
      cleanupEffects.current.push(...cancelFuncs);
    }
  }, [sideEffects]);
  React.useEffect(() => (() => {
    cleanupEffects.current.forEach(cb => cb());
  }), []);
  return [
    state,
    dispatch
  ];
}

function useWithMapState(reducer, getInitialState) {
  let cleanupEffects = React.useRef([]);
  let match = React.useReducer((fullState, action) => {
    let state = reducer(fullState.state, action);
    if (typeof state !== "object") {
      return fullState;
    }
    switch (state.TAG) {
      case "Update" :
        return {
          state: state._0,
          sideEffects: fullState.sideEffects
        };
      case "UpdateWithSideEffects" :
        return {
          state: state._0,
          sideEffects: {
            contents: Belt_Array.concatMany([
              fullState.sideEffects.contents,
              [state._1]
            ])
          }
        };
      case "SideEffects" :
        return {
          state: fullState.state,
          sideEffects: {
            contents: Belt_Array.concatMany([
              fullState.sideEffects.contents,
              [state._0]
            ])
          }
        };
    }
  }, undefined, () => ({
    state: getInitialState(),
    sideEffects: {
      contents: []
    }
  }));
  let dispatch = match[1];
  let match$1 = match[0];
  let sideEffects = match$1.sideEffects;
  let state = match$1.state;
  React.useEffect(() => {
    if (sideEffects.contents.length !== 0) {
      let sideEffectsToRun = sideEffects.contents.slice();
      sideEffects.contents = [];
      let cancelFuncs = Stdlib_Array.filterMap(sideEffectsToRun, func => func({
        dispatch: dispatch,
        state: state
      }));
      cleanupEffects.current.push(...cancelFuncs);
    }
  }, [sideEffects]);
  React.useEffect(() => (() => {
    cleanupEffects.current.forEach(cb => cb());
  }), []);
  return [
    state,
    dispatch
  ];
}

export {
  use,
  useWithMapState,
}
/* react Not a pure module */
